import { InputAdornment } from '@mui/material';
import React from 'react';

export const startAdornment = (
    <InputAdornment position="start">€</InputAdornment>
);
export const endAdornment = <InputAdornment position="end">€</InputAdornment>;
export const percentageEndAdornment = (
    <InputAdornment position="end">%</InputAdornment>
);
